"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _extends = require("@babel/runtime/helpers/extends");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.XMPPClient = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _client = _interopRequireDefault(require("stanza.io/lib/client"));
var _Database = require("../Database");
var _XHR = require("../XHR");
var _cookies = _interopRequireDefault(require("../Helpers/cookies"));
var storeAction = _interopRequireWildcard(require("../Store"));
var _xmpp = require("../Constants/xmpp");
var _constants = require("../Constants/constants");
var _objects = require("../Helpers/objects");
var _auth = require("../Helpers/auth");
var _XMPPEventEmitter = require("../XMPPEventEmitter/XMPPEventEmitter");
var _localStorage = require("../Helpers/localStorage");
var _ChatEventsEmitter = require("../ChatEventsEmitter/ChatEventsEmitter");
var _excluded = ["question_text", "question_id", "related_ad_param", "sub_topic_display", "subtopic"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = _extends({}, null), a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable promise/no-nesting */ /* eslint-disable promise/no-promise-in-callback */ /* eslint-disable max-lines */ /* global window */
var timeout = 40000;
var interventionDb = new _Database.InterventionDatabase();
var connectionInitiated = false;
var chatDb;
var completeFirstLoad;
var didCompleteFirstLoad = false;
var QUEUE_LENGTH = 5;
var API_RETRY_TIMER = 1000;
var TOKEN_TIME = 1000;
var KYC = 'kyc';
var didLoadFirstTime = new Promise(function (resolve) {
  completeFirstLoad = resolve;
});
var XMPPClient = exports.XMPPClient = /*#__PURE__*/function () {
  function XMPPClient(store, _ref) {
    var _this = this;
    var config = _ref.config,
      variant = _ref.variant;
    (0, _classCallCheck2.default)(this, XMPPClient);
    (0, _defineProperty2.default)(this, "dispatchXMPPEvent", function (event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return function () {
        return _XMPPEventEmitter.XMPPEventEmitter.dispatch.apply(_XMPPEventEmitter.XMPPEventEmitter, [event].concat(args));
      };
    });
    (0, _defineProperty2.default)(this, "getExpiration", function () {
      var expirationInDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var minusSeconds = 1000;
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + expirationInDays);
      var expiration = new Date(tomorrow.setHours(0, 0, 0, 0) - minusSeconds);
      return expiration;
    });
    (0, _defineProperty2.default)(this, "saveReplyRestrictionValue", function (key, value) {
      var expirationInDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var expiration = _this.getExpiration(expirationInDays);
      _cookies.default.createCookie(key, value, undefined, undefined, expiration);
    });
    (0, _defineProperty2.default)(this, "getKYCMetaData", function () {
      try {
        if ((0, _localStorage.supportLocalStorage)()) {
          var kycMetaDta = window.localStorage.getItem(_constants.KYC_REPLY_RESTRICTION_METADATA);
          return kycMetaDta ? JSON.parse(kycMetaDta) : {};
        }
      } catch (e) {
        return {};
      }
      return {};
    });
    (0, _defineProperty2.default)(this, "saveKYCReplyRestriction", function (value) {
      var kycMetaData = _this.getKYCMetaData();
      var expirationInDays = 1;
      try {
        expirationInDays = (0, _objects.isEmpty)(kycMetaData) ? 1 : Number(kycMetaData.time);
      } catch (e) {
        expirationInDays = 1;
      }
      var expiration = _this.getExpiration(expirationInDays);
      _cookies.default.createCookie(_constants.KYC_REPLY_COUNT, value, undefined, undefined, expiration);
    });
    (0, _defineProperty2.default)(this, "saveUserPreferenceData", function (data) {
      if ((0, _localStorage.supportLocalStorage)()) {
        window.localStorage.setItem('reply_restriction', JSON.stringify(data));
        window.localStorage.setItem('safety_tips_chat', data.contextual_tips_off);
        window.localStorage.setItem('auto_reply', data.auto_reply);
        window.localStorage.setItem('auto_reply_visible_in_session', data.auto_reply);
        window.localStorage.setItem(_constants.KYC_EXPERIMENT, data[_constants.KYC_EXPERIMENT]);
        window.localStorage.setItem(_constants.KYC_EXPERIMENT_SELLER, data[_constants.KYC_EXPERIMENT_SELLER]);
      }
      if ('reply_restriction' in data) {
        _this.saveReplyRestrictionValue('reply_restriction', data.reply_restriction);
      }
      if (_constants.KYC_REPLY_COUNT in data) {
        _this.saveKYCReplyRestriction(data[_constants.KYC_REPLY_COUNT]);
      }
    });
    (0, _defineProperty2.default)(this, "setUserPreference", function (postData) {
      var token = _this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN);
      var data = {
        url: "".concat(_this.config.APIDomain).concat(_this.config.userPreferences),
        token: token,
        postData: postData
      };
      return (0, _XHR.setUserPreferenceData)(data).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (e) {
        // window.newrelic?.addPageAction('error_in_user_preference_api_variant', {
        //     e
        // });
      });
    });
    (0, _defineProperty2.default)(this, "getUserPreference", function () {
      var token = _this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN);
      (0, _XHR.getUserPreferenceData)("".concat(_this.config.APIDomain).concat(_this.config.userPreferences), token).then(function (userPreferenceData) {
        if (userPreferenceData) {
          _this.saveUserPreferenceData(userPreferenceData);
        }
      }).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (e) {
        // window.newrelic?.addPageAction('error_in_user_preference_api', {
        //     e
        // });
      });
    });
    (0, _defineProperty2.default)(this, "retryRequest", function (fn, args) {
      setTimeout(function () {
        fn.apply(_this, args);
      }, API_RETRY_TIMER);
    });
    (0, _defineProperty2.default)(this, "getLastMessageByThread", function (otherUser, itemId, callback) {
      return chatDb && chatDb.getLastMessageByThread(otherUser, itemId, callback);
    });
    (0, _defineProperty2.default)(this, "getNewReceivedSystemMessages", function (messages) {
      return chatDb && chatDb.getNewReceivedSystemMessages(messages);
    });
    (0, _defineProperty2.default)(this, "getUserBuyIntentList", function (callback) {
      if (window !== 'undefined') {
        var _chatDb;
        return (_chatDb = chatDb) === null || _chatDb === void 0 ? void 0 : _chatDb.getUserBuyIntentThreads(_this.user.id, callback);
      }
      return null;
    });
    (0, _defineProperty2.default)(this, "getThreads", function (callback) {
      return chatDb && chatDb.getThreads(_this.user.id, callback);
    });
    (0, _defineProperty2.default)(this, "getThreadMessages", function (otherUser, itemId, callback) {
      return chatDb && chatDb.getThreadMessages(otherUser, itemId, callback);
    });
    (0, _defineProperty2.default)(this, "updatePresence", function (presence) {
      var user = _this.removeCountryCode(presence.from.local);
      var type = (0, _typeof2.default)(presence.idle) === 'object' ? 'unavailable' : presence.type;
      if (user === _this.addCountryCode(_this.user.id) || type === 'subscribed' || type === 'error') {
        return Promise.resolve();
      }
      if (type === 'subscribe') {
        _this.acceptSubscription(user);
        return Promise.resolve();
      }
      _this.userPresence[user] = type;
      return chatDb && chatDb.updatePresence(user, type);
    });
    (0, _defineProperty2.default)(this, "resetRequestQueue", function () {
      if (_this.requestQueue && _this.requestQueue.length) {
        if (_this.runningQueue && _this.runningQueue.length) {
          Promise.all(_this.runningQueue).then(function () {
            _this.requestQueue = [];
          }).catch(function () {
            _this.requestQueue = [];
          });
        } else {
          _this.requestQueue = [];
        }
      }
    });
    (0, _defineProperty2.default)(this, "preFetchMessagesByThread", function (queryParams) {
      return function () {
        return _this.getBulkMessages(queryParams);
      };
    });
    (0, _defineProperty2.default)(this, "filterSenderTypeQuestions", function (questions) {
      var questionTypeOfSender = _constants.QUESTION_TYPES;
      return questions.filter(function (question) {
        return question.type && questionTypeOfSender.indexOf(question.type) >= 0;
      });
    });
    (0, _defineProperty2.default)(this, "updateReplyToProps", function (replyTo) {
      var reply_to = _objectSpread({}, replyTo);
      return {
        text: true,
        from: _this.addFullCode(reply_to.from)
      };
    });
    (0, _defineProperty2.default)(this, "sendMessage", function (_ref2) {
      var _this$config, _this$config2;
      var message = _ref2.message,
        userId = _ref2.userId,
        itemId = _ref2.itemId,
        type = _ref2.type,
        typeParams = _ref2.typeParams,
        id = _ref2.id,
        _ref2$extras = _ref2.extras,
        extras = _ref2$extras === void 0 ? {} : _ref2$extras,
        lead_info = _ref2.lead_info,
        _ref2$categoryId = _ref2.categoryId,
        categoryId = _ref2$categoryId === void 0 ? '' : _ref2$categoryId,
        _ref2$dealerType = _ref2.dealerType,
        dealerType = _ref2$dealerType === void 0 ? '' : _ref2$dealerType,
        _ref2$isTestDriveEnab = _ref2.isTestDriveEnabled,
        isTestDriveEnabled = _ref2$isTestDriveEnab === void 0 ? '' : _ref2$isTestDriveEnab,
        replyTo = _ref2.replyTo,
        customReply = _ref2.customReply,
        sellerId = _ref2.sellerId;
      var obj = {
        to: _this.addFullCode(userId),
        from: _this.addFullCode(_this.user.id),
        body: message,
        type: 'chat',
        state: 'active',
        markable: true,
        extras: _objectSpread({
          itemId: itemId,
          categoryId: categoryId,
          countryId: "".concat(_this.domain),
          senderType: id === _this.user.id ? 'seller' : 'buyer',
          dealerType: dealerType,
          isTestDriveEnabled: isTestDriveEnabled,
          sellerId: sellerId,
          creation_source: ((_this$config = _this.config) === null || _this$config === void 0 ? void 0 : _this$config.appkey) || _xmpp.PANAMERA,
          app_key: ((_this$config2 = _this.config) === null || _this$config2 === void 0 ? void 0 : _this$config2.appkey) || _xmpp.PANAMERA
        }, extras),
        lead_info: lead_info
      };
      if (type === 'info') {
        obj.info = true;
      } else if (type === 'image') {
        obj.image = typeParams;
      } else if (type === 'voice') {
        obj.voice = typeParams;
      } else if (type === 'location') {
        obj.location = typeParams;
      } else if (type === 'sms') {
        obj.sms = true;
      } else if (type === 'call') {
        obj.call = true;
      } else if (type === 'escrowInterest') {
        obj.escrowInterest = true;
      } else if (type === 'actionable') {
        obj.actionable = typeParams;
      } else {
        if (type === 'intervention') {
          obj.extras = Object.assign({}, obj.extras, typeParams);
        }
        obj.text = true;
      }
      if (replyTo) {
        var replyToMessage = _this.updateReplyToProps(replyTo);
        obj.reply_to = _objectSpread(_objectSpread({}, replyTo), replyToMessage);
        obj.extras.custom_reply = customReply ? 'true' : 'false';
      }
      _this.setHealthStatus();
      _this.logMessage(obj);
      return _this.client.sendMessage(obj);
    });
    (0, _defineProperty2.default)(this, "sendState", function (userId, chatState, itemId) {
      if (_this.connEstablished) {
        _this.setHealthStatus();
        _this.client.sendMessage({
          to: _this.addFullCode(userId),
          chatState: chatState,
          noStore: true,
          noStorage: true,
          extras: {
            itemId: itemId
          },
          from: _this.addFullCode(_this.user.id)
        });
      }
    });
    (0, _defineProperty2.default)(this, "setTracker", function () {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      _this.tracker = track;
    });
    chatDb = new _Database.ChatDatabase(store);
    this.store = store;
    this.config = config;
    this.connEstablished = false;
    this.mamStart = undefined;
    this.domain = this.config.domain;
    this.retryTime = this.config.retryTime;
    this.retryTrail = this.config.retryTrail;
    // this.refreshUserPresence = onUserUpdate;
    this.user = JSON.parse(decodeURIComponent(_cookies.default.readCookie('user')).substr(2));
    this.latestMsgObj = {};
    this.blockList = [];
    this.userPresence = {};
    this.updateTime = false;
    this.mamEnabled = this.checkIfMamEnabled();
    this.getJWTCount = 0;
    this.setTracker();
    this.variant = variant;
    var ct = _cookies.default.readCookie('ct');
    if (ct && ct !== 'undefined') {
      this.setData({
        chatToken: ct
      });
    } else {
      this.fetchToken().then(function (newToken) {
        if (newToken) {
          _this.setData({
            chatToken: newToken
          });
        }
      }).catch(function () {});
    }
  }
  (0, _createClass2.default)(XMPPClient, [{
    key: "checkIfMamEnabled",
    value: function checkIfMamEnabled() {
      var data = this.getStorageItem('_bifro_features');
      return data && !JSON.parse(data).http_chat_history || false;
    }
  }, {
    key: "refreshChatToken",
    value: function refreshChatToken(cb) {
      return cb(_cookies.default.readCookie('ct'));
    }
  }, {
    key: "fetchToken",
    value: function fetchToken() {
      return Promise.resolve(_cookies.default.readCookie('ct'));
    }
  }, {
    key: "setData",
    value: function setData(_ref3) {
      var _this2 = this;
      var chatToken = _ref3.chatToken;
      var breakPoint = 768;
      var resource = window && window.screen.availWidth < breakPoint ? 'pwaMobile' : 'pwaDesktop'; // eslint-disable-line

      this.chatToken = chatToken;
      var val = this.checkAuthToken(this.chatToken, 'constructor');
      if (!val) {
        connectionInitiated = false;
        return;
      }
      this.obj = {
        jid: this.addFullCode(this.user.id),
        password: this.chatToken,
        transport: 'websocket',
        resource: "".concat(resource, "-").concat(Date.now()),
        useStreamManagement: true,
        wsURL: this.config.wsUrl,
        timeout: 50000
      };
      this.client = XMPPClient.createStanzaClient(this.obj);
      this.client.use(this.setCustomMessage.bind(this));
      this.client.use(this.setChatMarkers.bind(this));
      this.client.on('session:started', function () {
        _this2.mamStart = true;
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', {
          state: 'start'
        });
        _this2.onSessionStart().then(_XMPPEventEmitter.XMPPEventEmitter.dispatch('onDisconnect', _this2.connEstablished)).catch(function () {});
      });
      this.client.on('stream:management:resumed', function () {
        _this2.sendConnectionStatus(true);
      });
      this.client.on('message:sent', function (message) {
        if (didCompleteFirstLoad) {
          if (message.type === 'chat') {
            _this2.tracker('item_chat_tap_send_success', {
              resultset_id: message.id
            });
          }
          _this2.saveMessage(message).then(function () {
            return _this2.client.emit('messages:received');
          }).catch(function () {});
        } else {
          didLoadFirstTime.then(function () {
            if (message.type === 'chat') {
              _this2.tracker('item_chat_tap_send_success', {
                resultset_id: message.id
              });
            }
            _this2.saveMessage(message).then(function () {
              return _this2.client.emit('messages:received');
            }).catch(function () {});
          }).catch(function () {});
        }
      });
      this.client.on('chat', function (chat) {
        if (didCompleteFirstLoad) {
          _this2.saveMessage(chat).then(function () {
            return _this2.client.emit('messages:received');
          }).catch(function () {});
        } else {
          didLoadFirstTime.then(function () {
            _this2.saveMessage(chat).then(function () {
              return _this2.client.emit('messages:received');
            }).catch(function () {});
          }).catch(function () {});
        }
      });
      this.client.on('disconnected', function () {
        _this2.onChatDisconnect();
      });
      this.client.on('auth:failed', function (event) {
        _this2.findExpiryForToken();
        _this2.trackAuthFailure(event);
        _this2.updateAuthEvents();
      });
      this.client.on('message:receipt', function (id) {
        _this2.markReceived(id, function () {
          return _this2.client.emit('messages:received');
        });
      });
      this.client.on('message:displayed', function (id) {
        _this2.markDisplayed(id, function () {
          return _this2.client.emit('messages:received');
        });
      });
      this.client.on('mamComplete', function (obj) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', obj);
      });
      this.client.on('jwt:saved', function () {
        _this2.getUserMessages();
        _this2.getUserPreference();
        _this2.storeQuestionsCloudData();
      });
      this.client.on('intervention:change', function (obj) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onInterventionChange', obj);
      });
      this.client.on('custom:chat:state', function (chatState) {
        return _XMPPEventEmitter.XMPPEventEmitter.dispatch('onStatusChange', chatState);
      });
      this.client.on('custom:chat:autoReply', function (chatState) {
        return _XMPPEventEmitter.XMPPEventEmitter.dispatch('onAutoReplyMessageReceive', chatState);
      });
      this.updateUserEvents();
      this.client.on('messages:received', this.dispatchXMPPEvent('onReceive'));
      this.client.connect();
      chatDb.syncUserData();
    }
  }, {
    key: "replaceListeners",
    value: function replaceListeners(_ref4) {
      var _this3 = this;
      var config = _ref4.config;
      var val = this.checkAuthToken(this.chatToken, 'update');
      if (!val || !config) {
        return;
      }
      if (this.mamStart) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', {
          state: 'start'
        });
      } else if (this.mamStart === false) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', {
          state: 'end'
        });
      } else {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', {
          state: 'continue'
        });
      }
      this.client.off('custom:chat:state');
      this.client.on('custom:chat:state', function (chatState) {
        return _XMPPEventEmitter.XMPPEventEmitter.dispatch('onStatusChange', chatState);
      });
      this.client.off('custom:chat:autoReply');
      this.client.on('custom:chat:autoReply', function (chatState) {
        return _XMPPEventEmitter.XMPPEventEmitter.dispatch('onAutoReplyMessageReceive', chatState);
      });
      this.client.off('messages:received');
      this.client.on('messages:received', this.dispatchXMPPEvent('onReceive'));
      this.client.off('session:started');
      this.client.on('session:started', function () {
        _this3.mamStart = true;
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', {
          state: 'start'
        });
        _this3.onSessionStart().then(_XMPPEventEmitter.XMPPEventEmitter.dispatch('onDisconnect', _this3.connEstablished)).catch(function () {});
      });
      this.client.off('stream:management:resumed');
      this.client.on('stream:management:resumed', function () {
        _this3.sendConnectionStatus(true);
      });
      this.client.off('disconnected');
      this.client.on('disconnected', function () {
        _this3.onChatDisconnect();
      });
      this.client.off('auth:failed');
      this.client.on('auth:failed', function (event) {
        _this3.findExpiryForToken();
        _this3.trackAuthFailure(event);
        _this3.updateAuthEvents();
      });
      this.client.off('mamComplete');
      this.client.on('mamComplete', function (obj) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onMamComplete', obj);
      });
      this.client.off('intervention:change');
      this.client.on('intervention:change', function (obj) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onInterventionChange', obj);
      });
      _XMPPEventEmitter.XMPPEventEmitter.dispatch('onDisconnect', this.connEstablished);
      // this.refreshUserPresence = onUserUpdate;
      this.updateUserEvents();
    }
  }, {
    key: "onChatDisconnect",
    value: function onChatDisconnect() {
      if (this.client) {
        this.onMamEnd();
        this.sendConnectionStatus(false);
      }
    }
  }, {
    key: "retryChatConnection",
    value: function retryChatConnection() {
      var _this4 = this;
      if (this.retryTrail === this.config.retryTrail) {
        this.retryTrail--;
        this.connect();
      } else if (this.retryTrail > 0) {
        this.retryTrail--;
        setTimeout(function () {
          _this4.connect();
        }, this.retryTime);
      }
    }
  }, {
    key: "resetRetryTimer",
    value: function resetRetryTimer() {
      if (this.retryTrail !== this.config.retryTrail) {
        this.retryTrail = this.config.retryTrail;
      }
    }
  }, {
    key: "sendConnectionStatus",
    value: function sendConnectionStatus(val) {
      var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.connEstablished = val;
      connectionInitiated = false;
      this.setHealthStatus();
      _XMPPEventEmitter.XMPPEventEmitter.dispatch('onDisconnect', val, retry, this.retryTrail === this.config.retryTrail);
      if (!val && window.navigator && window.navigator.onLine) {
        this.retryChatConnection();
      }
    }
  }, {
    key: "updateUserEvents",
    value: function updateUserEvents() {
      var _this5 = this;
      this.client.off('presence');
      this.client.on('presence', function (presence) {
        _this5.updatePresence(presence);
      });
      this.client.off('block');
      this.client.on('block', function (block) {
        block.jids.forEach(function (jid) {
          _this5.blockList.push(jid.local);
          _this5.updateBlock(_this5.removeCountryCode(jid.local), true);
        });
      });
      this.client.off('unblock');
      this.client.on('unblock', function (unblock) {
        unblock.jids.forEach(function (jid) {
          var index = _this5.blockList.indexOf(jid.local);
          _this5.blockList.splice(index, 1);
          _this5.updateBlock(_this5.removeCountryCode(jid.local), false);
        });
      });
    }
  }, {
    key: "updateAuthEvents",
    value: function updateAuthEvents() {
      if (this.retryTrail <= 0) {
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onAuthFailure', true, this.chatToken);
      }
    }
  }, {
    key: "findExpiryForToken",
    value: function findExpiryForToken() {
      var ct = _cookies.default.readCookie('ct');
      if (ct) {
        try {
          var _parseToken = (0, _auth.parseToken)(ct),
            exp = _parseToken.exp;
          this.trackTokenExpiry(undefined, exp, Date.now() > exp * TOKEN_TIME);
        } catch (e) {
          this.trackTokenExpiry(e);
        }
      } else {
        this.trackTokenExpiry();
      }
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "trackAuthFailure",
    value: function trackAuthFailure(event) {
      // window.newrelic?.addPageAction('chat_auth_failed', {
      //     event_message: event && event.data,
      //     resource: this.client.config ? `${String(this.client.config.resource) }` : 'null',
      //     token: this.client.config ? `${String(this.client.config.password) }` : 'null',
      //     loc: window.location && window.location.pathname,
      //     user: this.user,
      //     user_id: this.user.id,
      //     local_token: this.getStorageItem('__ct__bifro_ct') ? `${String(this.getStorageItem('__ct__bifro_ct')) }` : 'null',
      //     cookie_token: cookieManagerHelper.readCookie('ct') ? `${String(cookieManagerHelper.readCookie('ct')) }` : 'null'
      // });
    }

    // eslint-disable-next-line handle-callback-err, no-unused-vars
  }, {
    key: "trackTokenExpiry",
    value: function trackTokenExpiry(error, expiry, isTokenExpired) {
      // window.newrelic?.addPageAction('chat_token_error', {
      //     error,
      //     expiry,
      //     isTokenExpired,
      //     resource: this.client.config ? `${String(this.client.config.resource) }` : 'null',
      //     token: this.client.config ? `${String(this.client.config.password) }` : 'null',
      //     loc: window.location && window.location.pathname,
      //     user: this.user,
      //     user_id: this.user.id,
      //     cookie_token: cookieManagerHelper.readCookie('ct') ? `${String(cookieManagerHelper.readCookie('ct')) }` : 'null'
      // });
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "checkAuthToken",
    value: function checkAuthToken(t, calledBy) {
      if (!t || t === 'null' || t === 'undefined') {
        // window.newrelic?.addPageAction('chat_auth_error', {
        //     token: this.getStorageItem('__ct__bifro_ct'),
        //     user: this.user,
        //     user_id: this.user.id,
        //     calledBy,
        //     chat_token: t,
        //     cookie_token: cookieManagerHelper.readCookie('ct'),
        //     loc: window.location && window.localStorage.pathname
        // });
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onAuthFailure', true, t);
        return false;
      }
      return true;
    }
  }, {
    key: "setCustomMessage",
    value: function setCustomMessage(client, stanzas) {
      var _this6 = this;
      client.disco.addFeature('jabber:iq:mamremove');
      var extras = stanzas.define({
        name: 'extras',
        element: 'extras',
        topLevel: true,
        namespace: 'urn:xmpp:extras',
        fields: {
          countryId: stanzas.utils.attribute('countryId'),
          messageType: stanzas.utils.attribute('messageType'),
          itemId: stanzas.utils.attribute('itemId'),
          actionId: stanzas.utils.attribute('actionId'),
          leadFormType: stanzas.utils.attribute('leadFormType'),
          interventionId: stanzas.utils.attribute('interventionId'),
          senderType: stanzas.utils.attribute('senderType'),
          dealerType: stanzas.utils.attribute('dealerType'),
          params: stanzas.utils.attribute('params'),
          name: stanzas.utils.attribute('name'),
          phone: stanzas.utils.attribute('phone'),
          email: stanzas.utils.attribute('email'),
          categoryId: stanzas.utils.attribute('categoryId'),
          isTestDriveEnabled: stanzas.utils.attribute('isTestDriveEnabled'),
          isFinanceNeeded: stanzas.utils.attribute('isFinanceNeeded'),
          isExchangeInterested: stanzas.utils.attribute('isExchangeInterested'),
          custom_reply: stanzas.utils.attribute('custom_reply'),
          callRequested: stanzas.utils.attribute('callRequested'),
          quote_gclid: stanzas.utils.attribute('quote_gclid'),
          quote_utmcampaign: stanzas.utils.attribute('quote_utmcampaign'),
          quote_utmcampaignId: stanzas.utils.attribute('quote_utmcampaignId'),
          quote_utmcontent: stanzas.utils.attribute('quote_utmcontent'),
          quote_utmmedium: stanzas.utils.attribute('quote_utmmedium'),
          quote_utmsource: stanzas.utils.attribute('quote_utmsource'),
          quote_utmterm: stanzas.utils.attribute('quote_utmterm'),
          creation_source: stanzas.utils.attribute('creation_source'),
          buyerId: stanzas.utils.attribute('buyerId'),
          sellerId: stanzas.utils.attribute('sellerId'),
          app_key: stanzas.utils.attribute('app_key')
        }
      });
      var lead_info = stanzas.define({
        name: 'lead_info',
        element: 'lead_info',
        topLevel: true,
        namespace: 'urn:xmpp:lead_info',
        fields: {
          name: stanzas.utils.attribute('name'),
          phone: stanzas.utils.attribute('phone'),
          email: stanzas.utils.attribute('email'),
          leadFormType: stanzas.utils.attribute('leadFormType'),
          leadId: stanzas.utils.attribute('leadId'),
          extras: stanzas.utils.attribute('extras')
        }
      });
      var store = stanzas.define({
        name: 'store',
        element: 'store',
        namespace: 'urn:xmpp:hints'
      });
      var noStore = stanzas.define({
        name: 'noStore',
        element: 'no-store',
        namespace: 'urn:xmpp:hints'
      });
      var noStorage = stanzas.define({
        name: 'noStorage',
        element: 'no-storage',
        namespace: 'urn:xmpp:hints'
      });
      var idle = stanzas.define({
        name: 'idle',
        element: 'idle',
        namespace: 'urn:xmpp:idle:1',
        fields: {
          since: stanzas.utils.attribute('since')
        }
      });
      var lastActivity = stanzas.define({
        name: 'query',
        element: 'query',
        namespace: 'jabber:iq:last',
        fields: {
          seconds: stanzas.utils.attribute('seconds')
        }
      });
      var info = stanzas.define({
        name: 'info',
        element: 'info',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var text = stanzas.define({
        name: 'text',
        element: 'text',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var image = stanzas.define({
        name: 'image',
        element: 'image',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          url: stanzas.utils.attribute('url'),
          thumb: stanzas.utils.attribute('thumb')
        }
      });
      var voice = stanzas.define({
        name: 'voice',
        element: 'voice',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          url: stanzas.utils.attribute('url'),
          duration: stanzas.utils.attribute('duration')
        }
      });
      var location = stanzas.define({
        name: 'location',
        element: 'location',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          lat: stanzas.utils.attribute('lat'),
          lon: stanzas.utils.attribute('lon')
        }
      });
      var suggestion = stanzas.define({
        name: 'suggestion',
        element: 'suggestion',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          msgId: stanzas.utils.attribute('msg_id'),
          values: stanzas.utils.multiTextSub('urn:xmpp:type', 'value')
        }
      });
      var actionSuggestions = stanzas.define({
        name: 'actionSuggestions',
        element: 'action_suggestions',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          msgId: stanzas.utils.attribute('msg_id')
        }
      });
      var actions = stanzas.define({
        name: 'action',
        element: 'action',
        namespace: 'urn:xmpp:type',
        fields: {
          type: stanzas.utils.attribute('type'),
          text: stanzas.utils.text()
        }
      });
      var intervention = stanzas.define({
        name: 'intervention',
        element: 'intervention',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          action: stanzas.utils.attribute('action'),
          interventionId: stanzas.utils.attribute('id'),
          userId: stanzas.utils.attribute('with'),
          price: stanzas.utils.subAttribute('urn:xmpp:type', 'params', 'price')
        }
      });
      var replyRestriction = stanzas.define({
        name: 'replyRestriction',
        element: 'reply-restriction',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          blocked: stanzas.utils.attribute('blocked'),
          count: stanzas.utils.attribute('count'),
          cause: stanzas.utils.attribute('cause')
        }
      });
      var itemState = stanzas.define({
        name: 'itemState',
        element: 'item-state',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          itemId: stanzas.utils.attribute('itemId'),
          itemStatus: stanzas.utils.attribute('itemStatus')
        }
      });
      var peerState = stanzas.define({
        name: 'peerState',
        element: 'peer-state',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          peerId: stanzas.utils.attribute('peerId'),
          peerStatus: stanzas.utils.attribute('peerStatus')
        }
      });
      var deleteChat = stanzas.define({
        name: 'deleteChat',
        element: 'query',
        topLevel: true,
        namespace: 'jabber:iq:mamremove',
        fields: {
          jid: stanzas.utils.textSub('jabber:iq:mamremove', 'jid'),
          adid: stanzas.utils.textSub('jabber:iq:mamremove', 'adid')
        }
      });
      var result = stanzas.define({
        name: 'response',
        element: 'result',
        namespace: 'jabber:iq:mamremove',
        type: 'set',
        fields: {
          ns: stanzas.utils.attribute('xmlns'),
          id: stanzas.utils.attribute('id'),
          jid: stanzas.utils.textSub('jabber:iq:mamremove', 'jid'),
          adid: stanzas.utils.textSub('jabber:iq:mamremove', 'adid')
        }
      });
      var actionable = stanzas.define({
        name: 'actionable',
        element: 'actionable',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          subType: stanzas.utils.attribute('subType'),
          phone_request_status: stanzas.utils.attribute('phone_request_status'),
          phone_number: stanzas.utils.attribute('phone_number'),
          offer_id: stanzas.utils.attribute('offer_id'),
          buyer_offer: stanzas.utils.attribute('buyer_offer'),
          seller_offer: stanzas.utils.attribute('seller_offer'),
          offer_status: stanzas.utils.attribute('offer_status'),
          offer_category: stanzas.utils.attribute('offer_category'),
          question_id: stanzas.utils.attribute('question_id'),
          question_text: stanzas.utils.attribute('question_text'),
          related_ad_param: stanzas.utils.attribute('related_ad_param'),
          topic: stanzas.utils.attribute('topic'),
          subtopic: stanzas.utils.attribute('subtopic'),
          type: stanzas.utils.attribute('type'),
          meeting_status: stanzas.utils.attribute('meeting_status'),
          location: stanzas.utils.attribute('location'),
          date: stanzas.utils.attribute('date'),
          requested_by: stanzas.utils.attribute('requested_by'),
          cancelled_by: stanzas.utils.attribute('cancelled_by'),
          time: stanzas.utils.attribute('time'),
          end_time: stanzas.utils.attribute('end_time'),
          booking_id: stanzas.utils.attribute('booking_id'),
          appointment_id: stanzas.utils.attribute('appointment_id'),
          is_rescheduled: stanzas.utils.attribute('is_rescheduled')
        }
      });
      var sms = stanzas.define({
        name: 'sms',
        element: 'sms',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var call = stanzas.define({
        name: 'call',
        element: 'call',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var escrowInterest = stanzas.define({
        name: 'escrowInterest',
        element: 'escrowInterest',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var escrowEnabled = stanzas.define({
        name: 'escrowEnabled',
        element: 'escrowEnabled',
        topLevel: true,
        namespace: 'urn:xmpp:type'
      });
      var windowOpenEvent = stanzas.define({
        name: 'event',
        element: 'query',
        namespace: 'jabber:iq:event',
        fields: {
          name: stanzas.utils.textSub('jabber:iq:event', 'name'),
          to: stanzas.utils.textSub('jabber:iq:event', 'to'),
          itemId: stanzas.utils.textSub('jabber:iq:event', 'itemId'),
          senderType: stanzas.utils.textSub('jabber:iq:event', 'senderType')
        }
      });
      var jwtToken = stanzas.define({
        name: 'jwtToken',
        element: 'query',
        namespace: 'jabber:iq:jwt',
        fields: {
          jwt: stanzas.utils.textSub('jabber:iq:jwt', 'jwt')
        }
      });
      var deeplink = stanzas.define({
        name: 'deeplink',
        element: 'deeplink',
        namespace: 'urn:xmpp:deeplinks:item',
        fields: {
          label: stanzas.utils.textSub('urn:xmpp:deeplinks:item', 'label'),
          link: stanzas.utils.textSub('urn:xmpp:deeplinks:item', 'link')
        }
      });
      var deeplinks = stanzas.define({
        name: 'deeplinks',
        element: 'deeplinks',
        namespace: 'urn:xmpp:deeplinks'
      });
      var system = stanzas.define({
        name: 'system',
        element: 'system',
        topLevel: true,
        namespace: 'urn:xmpp:type',
        fields: {
          id: stanzas.utils.attribute('id'),
          layout: stanzas.utils.attribute('layout'),
          useDefault: stanzas.utils.attribute('useDefault'),
          subType: stanzas.utils.attribute('subType'),
          icon: stanzas.utils.textSub('urn:xmpp:type', 'icon'),
          title: stanzas.utils.textSub('urn:xmpp:type', 'title'),
          subtitle: stanzas.utils.textSub('urn:xmpp:type', 'subtitle'),
          email: stanzas.utils.textSub('urn:xmpp:type', 'email'),
          actionLabel: stanzas.utils.textSub('urn:xmpp:type', 'action_label')
        }
      });
      var replyTo = stanzas.define({
        name: 'reply_to',
        element: 'reply_to',
        topLevel: true,
        namespace: 'urn:xmpp:replyto',
        fields: {
          id: stanzas.utils.attribute('id'),
          from: stanzas.utils.attribute('from'),
          text: stanzas.utils.textSub('urn:xmpp:type', 'text'),
          body: stanzas.utils.textSub('urn:xmpp:replyto', 'body')
        }
      });
      var autoReply = stanzas.define({
        name: 'auto_reply',
        element: 'auto_reply',
        topLevel: true,
        namespace: 'urn:xmpp:hints'
      });
      var tipTo = stanzas.define({
        name: 'tip_to',
        element: 'tip_to',
        topLevel: true,
        namespace: 'urn:xmpp:tipto',
        fields: {
          msgId: stanzas.utils.attribute('msg_id')
        }
      });
      stanzas.extend(deeplinks, deeplink);
      stanzas.extend(system, deeplinks);
      stanzas.extend(actionSuggestions, actions, 'actions', true);
      stanzas.withPresence(function (Presence) {
        stanzas.extend(Presence, idle);
      });
      stanzas.withIQ(function (iq) {
        stanzas.extend(iq, lastActivity);
        stanzas.extend(iq, deleteChat);
        stanzas.extend(iq, result);
        stanzas.extend(iq, windowOpenEvent);
        stanzas.extend(iq, jwtToken);
      });
      stanzas.withMessage(function (Message) {
        stanzas.extend(Message, extras);
        stanzas.extend(Message, lead_info);
        stanzas.extend(Message, store);
        stanzas.extend(Message, noStore);
        stanzas.extend(Message, noStorage);
        stanzas.extend(Message, info);
        stanzas.extend(Message, text);
        stanzas.extend(Message, image);
        stanzas.extend(Message, voice);
        stanzas.extend(Message, location);
        stanzas.extend(Message, sms);
        stanzas.extend(Message, call);
        stanzas.extend(Message, escrowInterest);
        stanzas.extend(Message, escrowEnabled);
        stanzas.extend(Message, intervention);
        stanzas.extend(Message, system);
        stanzas.extend(Message, replyRestriction);
        stanzas.extend(Message, itemState);
        stanzas.extend(Message, peerState);
        stanzas.extend(Message, actionable);
        stanzas.extend(Message, suggestion);
        stanzas.extend(Message, autoReply);
        stanzas.extend(Message, replyTo);
        stanzas.extend(Message, tipTo);
        stanzas.extend(Message, actionSuggestions);
      });
      client.on('iq', function (data) {
        var res = data && data.response;
        var token = data && data.jwtToken;
        if (res && res.ns === 'jabber:iq:mamremove') {
          _this6.deleteUserChats(_this6.removeCountryCode(res.id), res.adid);
        }
        if (token && token.jwt) {
          _this6.saveJwtToken(token.jwt);
        }
      });
    }
  }, {
    key: "setChatMarkers",
    value: function setChatMarkers(client, stanzas) {
      var _this7 = this;
      client.disco.addFeature('urn:xmpp:chat-markers:0');
      var markable = stanzas.define({
        name: 'markable',
        element: 'markable',
        namespace: 'urn:xmpp:chat-markers:0'
      });
      var displayed = stanzas.define({
        name: 'displayed',
        element: 'displayed',
        namespace: 'urn:xmpp:chat-markers:0',
        fields: {
          id: stanzas.utils.attribute('id')
        }
      });
      var received = stanzas.define({
        name: 'received',
        element: 'received',
        namespace: 'urn:xmpp:chat-markers:0',
        fields: {
          id: stanzas.utils.attribute('id')
        }
      });
      stanzas.withMessage(function (Message) {
        stanzas.extend(Message, markable);
        stanzas.extend(Message, displayed);
        stanzas.extend(Message, received);
      });
      client.on('message', function (message) {
        if (message.from.local !== _this7.addCountryCode(_this7.user.id)) {
          if (message.displayed) {
            client.emit('message:displayed', message.displayed.id);
          } else if (message.received) {
            client.emit('message:receipt', message.received.id);
          } else if (message.markable && (!message.error || message.error.code !== '503')) {
            _this7.sendReceived(message);
          }
        }
        if ((0, _typeof2.default)(message.intervention) === 'object') {
          _this7.saveIntervention(message, Date.now());
        }
        if ((0, _typeof2.default)(message.suggestion) === 'object') {
          _this7.saveSuggestions(message.suggestion);
        }
        if ((0, _typeof2.default)(message.actionSuggestions) === 'object') {
          _this7.saveActionSuggestions(message.actionSuggestions);
        }
        if ((0, _typeof2.default)(message.replyRestriction) === 'object') {
          if ('blocked' in message.replyRestriction) {
            _this7.saveReplyRestrictionValue('reply_restriction', message.replyRestriction.blocked);
          }
          if (message.replyRestriction.cause === KYC) {
            _this7.saveKYCReplyRestriction(message.replyRestriction.count);
          }
        }
        if ((0, _typeof2.default)(message.itemState) === 'object') {
          var itemState = message.itemState;
          if (itemState.itemStatus) {
            _XMPPEventEmitter.XMPPEventEmitter.dispatch('refreshItem', itemState.itemId);
          }
        }
        if ((0, _typeof2.default)(message.peerState) === 'object') {
          var peerState = message.peerState;
          if (peerState.peerStatus) {
            _XMPPEventEmitter.XMPPEventEmitter.dispatch('refreshUser', peerState.peerId);
          }
        }
        if (message.chatState) {
          client.emit('custom:chat:state', {
            to: message.to,
            from: message.from,
            chatState: message.chatState,
            extras: message.extras
          });
        }
        if (message.auto_reply && (0, _typeof2.default)(message.auto_reply) === 'object') {
          client.emit('custom:chat:autoReply', {
            to: _this7.removeCountryCode(message.to.local),
            from: _this7.removeCountryCode(message.from.local),
            id: message.id,
            extras: message.extras
          });
        }
        if (message.carbonSent) {
          var messageData = message.carbonSent && message.carbonSent.forwarded && message.carbonSent.forwarded.message;
          if (messageData.displayed) {
            client.emit('message:displayed', messageData.displayed.id);
          } else if (messageData.received) {
            client.emit('message:receipt', messageData.received.id);
          }
          if (messageData.suggestion) {
            _this7.saveSuggestions(messageData.suggestion);
          }
          if (messageData.actionSuggestions) {
            _this7.saveActionSuggestions(message.actionSuggestions);
          }
          if (messageData.auto_reply && (0, _typeof2.default)(messageData.auto_reply) === 'object') {
            client.emit('custom:chat:autoReply', {
              to: _this7.removeCountryCode(messageData.to.local),
              from: _this7.removeCountryCode(messageData.from.local),
              id: messageData.id,
              extras: messageData.extras
            });
          }
          if ((0, _typeof2.default)(messageData.replyRestriction) === 'object') {
            if ('blocked' in message.replyRestriction) {
              _this7.saveReplyRestrictionValue('reply_restriction', message.replyRestriction.blocked);
            }
            if (message.replyRestriction.cause === KYC) {
              _this7.saveKYCReplyRestriction(message.replyRestriction.count);
            }
          }
        }
      });
    }
  }, {
    key: "setHealthStatus",
    value: function setHealthStatus() {
      var _this8 = this;
      clearInterval(this.timeout);
      if (this.connEstablished) {
        this.timeout = setInterval(function () {
          _this8.client.sendIq({
            id: 'c2s1',
            type: 'get',
            ping: true
          });
        }, timeout);
      }
    }
  }, {
    key: "getJwtToken",
    value: function getJwtToken() {
      this.client.sendIq({
        type: 'get',
        jwtToken: true,
        from: this.addFullCode(this.user.id)
      });
    }
  }, {
    key: "showLoadMoreOption",
    value: function showLoadMoreOption(pageToken) {
      storeAction.showLoadMore(this.store, pageToken);
    }
  }, {
    key: "loadMoreChats",
    value: function loadMoreChats(pageToken) {
      this.sendLoadMoreRequest(pageToken);
    }
  }, {
    key: "onSessionStart",
    value: function onSessionStart() {
      var _this9 = this;
      this.connEstablished = true;
      connectionInitiated = false;
      this.client.enableCarbons(function (err) {
        return err;
      });
      this.resetRetryTimer();
      this.getJwtToken();
      this.client.getBlocked(function (err, res) {
        if (err) {
          return;
        }
        if (res.blockList && res.blockList.jids) {
          _this9.blockList = res.blockList.jids.map(function (value) {
            return value.local;
          });
        }
      });
      this.setHealthStatus();
      return Promise.resolve();
    }
  }, {
    key: "saveJwtToken",
    value: function saveJwtToken(token) {
      if (window && window.localStorage) {
        window.localStorage.setItem(_xmpp.BIFROST_JWT_TOKEN, token);
        this.client.emit('jwt:saved');
      }
      this.sendPresence();
    }
  }, {
    key: "loadMessagesDataFromDB",
    value: function loadMessagesDataFromDB() {
      return chatDb.fetchMessageData(this.user.id);
    }
  }, {
    key: "loadThreadsDataFromDB",
    value: function loadThreadsDataFromDB() {
      return chatDb.fetchThreadData(this.user.id);
    }
  }, {
    key: "isInvalidTimestamp",
    value: function isInvalidTimestamp(time) {
      if (typeof time === 'number') {
        return false;
      } else if (typeof time === 'string') {
        return isNaN(parseInt(time, 10));
      }
      return true;
    }
  }, {
    key: "isInvalidQueryTimestamp",
    value: function isInvalidQueryTimestamp(time) {
      if (typeof time === 'number') {
        return false;
      } else if (typeof time === 'string') {
        return isNaN(parseInt(Date.parse(time), 10));
      }
      return true;
    }
  }, {
    key: "storeQuestionsCloudData",
    value: function storeQuestionsCloudData() {
      chatDb.placeQuestionsFromDBToStore();
    }
  }, {
    key: "getUserMessages",
    value: function getUserMessages() {
      var _this10 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var time = this.getAPIQueryTime();
      if (this.isInvalidQueryTimestamp(time)) {
        time = '';
        // window.newrelic?.addPageAction('invalid_chat_timestamp', {
        //     time
        // });
      }
      if (time) {
        chatDb.deleteExpiredThreadsAndMessages().then(function () {
          _this10.loadMessagesDataFromDB();
          _this10.loadThreadsDataFromDB();
        }).catch(function () {});
      } else {
        chatDb.clearMessages();
        chatDb.clearThreads();
      }
      this.sendHttpRequest(page, time);
      completeFirstLoad();
      didCompleteFirstLoad = true;
    }
  }, {
    key: "sendHttpRequest",
    value: function sendHttpRequest() {
      var _arguments = arguments,
        _this11 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.client.emit('mamComplete', {
        state: 'continue'
      });
      (0, _XHR.getUserThreads)(time, page, this.config.APIDomain, this.config.threadsAPI, this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN)).then(function (data) {
        if (data) {
          var threads = data.data;
          storeAction.fetchThreads(_this11.store);
          if (data.error === 'invalid') {
            if (_this11.getJWTCount < _this11.config.retryTrail) {
              _this11.getJWTCount++;
              _this11.getJwtToken();
              _this11.retryRequest(_this11.sendHttpRequest, _arguments);
            } else {
              _this11.onMamEnd();
            }
            return null;
          }
          _this11.getJWTCount = 0;
          if (threads.length) {
            _this11.client.emit('mamComplete', {
              state: 'continue'
            });
            var updatedAtTimestamps = [];
            for (var iThreadCount = 0; iThreadCount < threads.length; iThreadCount++) {
              var thread = threads[iThreadCount];
              if (_this11.isInvalidTimestamp(thread.updated_at)) {
                // window.newrelic?.addPageAction('invalid_chat_timestamp_api', {
                //     time: thread.updated_at,
                //     userId: this.user.id
                // });
              } else {
                updatedAtTimestamps.push(parseInt(thread.updated_at, 10));
              }
            }
            var timeForAPI = 0;
            if (updatedAtTimestamps.length) {
              timeForAPI = Math.max.apply(null, updatedAtTimestamps);
            }
            var newThreads = [];
            var deletedThreads = [];
            var currentTime = Date.now();
            threads.forEach(function (thread) {
              if (thread.deleted || thread.expires_on && thread.expires_on <= currentTime) {
                deletedThreads.push(thread);
              } else if (!chatDb.isThreadExpired(thread)) {
                newThreads.push(thread);
              }
            });
            if (time) {
              _this11.showLoadMoreOption(_this11.getNextPageToken());
              newThreads = _this11.markThreadsForUpdates(newThreads);
            } else {
              _this11.showLoadMoreOption(data.next_page);
              _this11.saveNextPageToken(data.next_page);
            }
            _this11.saveHttpThreads(newThreads, function (err) {
              if (err) {
                _this11.logMessageSaveError(err, 'chat_api_thread_save_failed');
              }
              _this11.fetchThreadData(newThreads, function () {
                _this11.getUnreadThreads(function (count) {
                  _this11.setChatCounter(count);
                });
              });
              if (timeForAPI) {
                _this11.updateAPIQueryTime(new Date(timeForAPI));
              }
            });
            _this11.removeHttpThreads(deletedThreads).then(function () {
              if (timeForAPI) {
                _this11.updateAPIQueryTime(new Date(timeForAPI));
              }
            }).catch(function () {});
            _this11.onMamEnd();
          } else {
            _this11.onMamEnd();
          }
        }
        return null;
      }).catch(function () {});
    }
  }, {
    key: "sendLoadMoreRequest",
    value: function sendLoadMoreRequest() {
      var _arguments2 = arguments,
        _this12 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      (0, _XHR.getUserThreads)(time, page, this.config.APIDomain, this.config.threadsAPI, this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN)).then(function (data) {
        if (data) {
          var threads = data.data;
          if (data.error === 'invalid') {
            if (_this12.getJWTCount < _this12.config.retryTrail) {
              _this12.getJWTCount++;
              _this12.getJwtToken();
              _this12.retryRequest(_this12.sendLoadMoreRequest, _arguments2);
            }
            return null;
          }
          _this12.getJWTCount = 0;
          if (threads.length) {
            _this12.saveHttpThreads(threads, function () {});
          }
          _this12.saveNextPageToken(data.next_page);
          _this12.showLoadMoreOption(data.next_page);
        }
        return null;
      }).catch(function () {});
    }
  }, {
    key: "removeHttpThreads",
    value: function removeHttpThreads(threads) {
      return Promise.all(threads.map(function (thread) {
        return chatDb.removeThread(thread.peer_id, thread.ad_id);
      }));
    }
  }, {
    key: "markThreadsForUpdates",
    value: function markThreadsForUpdates(threads) {
      return threads.map(function (thread) {
        return _objectSpread(_objectSpread({}, thread), {
          bNeedsUpdate: true
        });
      });
    }
  }, {
    key: "onMamEnd",
    value: function onMamEnd() {
      this.mamStart = false;
      this.client.emit('mamComplete', {
        state: 'end',
        latestMsgs: this.latestMsgObj
      });
    }
  }, {
    key: "updateQueryTime",
    value: function updateQueryTime() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if ((this.updateTime || update) && this.getStorageItem('_bifro_time') !== time) {
        window.localStorage.setItem('_bifro_time', time);
      }
    }
  }, {
    key: "updateAPIQueryTime",
    value: function updateAPIQueryTime(time) {
      window.localStorage.setItem('_bifro_updatedtime_threads', time);
    }
  }, {
    key: "getAPIQueryTime",
    value: function getAPIQueryTime() {
      return this.getStorageItem('_bifro_updatedtime_threads');
    }
  }, {
    key: "saveNextPageToken",
    value: function saveNextPageToken(token) {
      if (token) {
        window.localStorage.setItem('_bifro_next_page_token', token);
      } else {
        window.localStorage.removeItem('_bifro_next_page_token');
      }
    }
  }, {
    key: "getNextPageToken",
    value: function getNextPageToken() {
      return window.localStorage.getItem('_bifro_next_page_token');
    }
  }, {
    key: "getLastActivity",
    value: function getLastActivity(userId) {
      if (this.connEstablished) {
        return this.client.sendIq({
          to: this.addFullCode(userId),
          type: 'get',
          id: 'last1',
          query: true
        });
      }
      return Promise.resolve();
    }
  }, {
    key: "waitTillGetLastMessageByThread",
    value: function waitTillGetLastMessageByThread(otherUser, itemId, callback) {
      return didLoadFirstTime.then(function () {
        return chatDb && chatDb.getLastMessageByThread(otherUser, itemId, callback);
      });
    }
  }, {
    key: "getUnreadThreads",
    value: function getUnreadThreads(callback) {
      var data = this.getStorageItem('_bifro_features');
      var isTransaction = data && JSON.parse(data).transaction_inbox || false;
      return chatDb && chatDb.getUnreadThreadsWithData(this.user.id, callback, isTransaction);
    }
  }, {
    key: "setChatCounter",
    value: function setChatCounter(count) {
      storeAction.toggleUnreadChats(this.store, count);
      storeAction.setChatUnreadCounter(this.store, count);
    }
  }, {
    key: "getUnreadCountByThread",
    value: function getUnreadCountByThread(otherUser, itemId) {
      return chatDb && chatDb.getUnreadCountByThread(otherUser, itemId);
    }
  }, {
    key: "getDistinctConversationId",
    value: function getDistinctConversationId(otherUser) {
      return chatDb && chatDb.getDistinctConversationId(otherUser);
    }
  }, {
    key: "convertToString",
    value: function convertToString(id) {
      return id && (typeof id === 'string' ? id : id.toString());
    }
  }, {
    key: "removeCountryCode",
    value: function removeCountryCode(id) {
      return id && this.convertToString(id).split('_')[0];
    }
  }, {
    key: "addCountryCode",
    value: function addCountryCode(id) {
      return id && this.convertToString(id).concat("_".concat(this.domain));
    }
  }, {
    key: "addFullCode",
    value: function addFullCode(id) {
      return id && this.convertToString(id).concat("_".concat(this.domain, "@").concat(this.domain));
    }
  }, {
    key: "hasCountryCode",
    value: function hasCountryCode(id) {
      return id && this.convertToString(id).split('_').length > 1;
    }
  }, {
    key: "getStorageItem",
    value: function getStorageItem(key) {
      if (typeof window !== 'undefined') {
        var store = window.localStorage;
        return store && store.getItem(key);
      }
      return null;
    }
  }, {
    key: "getUsers",
    value: function getUsers(callback) {
      return chatDb && chatDb.getUsers(this.user.id, callback);
    }
  }, {
    key: "getUser",
    value: function getUser(id) {
      return chatDb && chatDb.getUser(id);
    }
  }, {
    key: "getItems",
    value: function getItems(messages) {
      return chatDb && chatDb.getItems(messages);
    }
  }, {
    key: "markReceived",
    value: function markReceived(messageId) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      return chatDb && chatDb.markReceived(messageId, callback);
    }
  }, {
    key: "markDisplayed",
    value: function markDisplayed(messageId) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      if (this.connEstablished) {
        return chatDb.markDisplayed(messageId, function () {
          callback();
        });
      }
      return null;
    }
  }, {
    key: "updateBlock",
    value: function updateBlock(userId, isBlock) {
      if (userId === this.user.id) {
        return Promise.resolve();
      }
      return chatDb && chatDb.updateBlock(userId, isBlock);
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "logMessage",
    value: function logMessage(msgObject) {
      // if (window.newrelic) {
      //     window.newrelic?.addPageAction('chat-message', msgObject);
      // }
    }
  }, {
    key: "sendDisplayed",
    value: function sendDisplayed(message) {
      this.setHealthStatus();
      var messageObject = {
        to: this.addFullCode(message.from),
        displayed: {
          id: message.id
        },
        from: this.addFullCode(message.to),
        type: 'chat',
        store: true,
        markable: true,
        extras: {
          itemId: message.itemId,
          countryId: "".concat(this.domain),
          messageType: this.getMessageType(message)
        }
      };
      this.client.sendMessage(messageObject);
      return this.markDisplayed(message.id);
    }
  }, {
    key: "sendReceived",
    value: function sendReceived(message) {
      this.setHealthStatus();
      var extras = message.extras;
      this.client.sendMessage({
        to: this.hasCountryCode(message.from) ? message.from : this.addFullCode(message.from),
        received: {
          id: message.id
        },
        from: this.hasCountryCode(message.to) ? message.to : this.addFullCode(message.to),
        type: 'chat',
        markable: true,
        extras: {
          itemId: extras ? extras.itemId : message.itemId,
          countryId: "".concat(this.domain),
          messageType: this.getMessageType(message)
        }
      });
      return this.markReceived(message.id);
    }
  }, {
    key: "deleteUserChats",
    value: function deleteUserChats(userId, itemId) {
      var _this13 = this;
      return chatDb && chatDb.deleteUserChats(userId, itemId).then(function () {
        return _this13.client.emit('messages:received');
      });
    }
  }, {
    key: "deleteBulkUserChats",
    value: function deleteBulkUserChats(userThreads) {
      var _this14 = this;
      return chatDb && chatDb.deleteBulkUserChats(userThreads).then(function () {
        return _this14.client.emit('messages:received');
      });
    }
  }, {
    key: "isMessage",
    value: function isMessage(msg) {
      return msg.body || (0, _typeof2.default)(msg.text) === 'object' || (0, _typeof2.default)(msg.call) === 'object' || (0, _typeof2.default)(msg.image) === 'object' || (0, _typeof2.default)(msg.actionable) === 'object' || (0, _typeof2.default)(msg.voice) === 'object' || (0, _typeof2.default)(msg.location) === 'object' || (0, _typeof2.default)(msg.sms) === 'object' || (0, _typeof2.default)(msg.system) === 'object';
    }
  }, {
    key: "isHttpMessage",
    value: function isHttpMessage(msg) {
      return msg.text || msg.type === 'call' || msg.type === 'sms' || msg.type === 'image' || msg.type === 'location' || msg.type === 'voice' || msg.type === 'actionable' || msg.type === 'system';
    }
  }, {
    key: "saveIntervention",
    value: function saveIntervention(msg, date) {
      var _this15 = this;
      interventionDb.saveIntervention(msg, date).then(function (obj) {
        _this15.client.emit('intervention:change', obj);
      }).catch(function () {});
    }
  }, {
    key: "saveSuggestions",
    value: function saveSuggestions(_ref5) {
      var _this16 = this;
      var msgId = _ref5.msgId,
        values = _ref5.values;
      return this.addMessageSuggestion(msgId, values || [], function (message, suggestions) {
        if (message) {
          _this16.tracker('sr_reply_load', {
            resultset_id: message.id,
            buyer_id: message.userId,
            result_count: suggestions && suggestions.length
          });
        }
        _this16.client.emit('messages:received');
      });
    }
  }, {
    key: "saveActionSuggestions",
    value: function saveActionSuggestions(_ref6) {
      var msgId = _ref6.msgId,
        actions = _ref6.actions;
      return this.saveSuggestions({
        msgId: msgId,
        values: actions
      });
    }
  }, {
    key: "markMessageAsReplied",
    value: function markMessageAsReplied(_ref7) {
      var _this17 = this;
      var id = _ref7.reply_to.id;
      return chatDb && chatDb.markMessageAsReplied(id, function () {
        _this17.saveSuggestions({
          msgId: id
        });
      });
    }
  }, {
    key: "messageHasThread",
    value: function messageHasThread(message) {
      return chatDb && chatDb.findThread(message);
    }
  }, {
    key: "getMessageType",
    value: function getMessageType(message) {
      if ((0, _typeof2.default)(message.location) === 'object') {
        return 'location';
      } else if ((0, _typeof2.default)(message.image) === 'object') {
        return 'image';
      } else if ((0, _typeof2.default)(message.voice) === 'object') {
        return 'voice';
      } else if ((0, _typeof2.default)(message.info) === 'object') {
        return 'info';
      } else if ((0, _typeof2.default)(message.sms) === 'object') {
        return 'sms';
      } else if ((0, _typeof2.default)(message.call) === 'object') {
        return 'call';
      } else if ((0, _typeof2.default)(message.system) === 'object') {
        return 'system';
      } else if ((0, _typeof2.default)(message.actionable) === 'object') {
        return 'actionable';
      }
      return 'text';
    }
  }, {
    key: "getOfferPayload",
    value: function getOfferPayload(message) {
      if (message && message.actionable) {
        return {
          offerId: message.actionable.offer_id,
          offerStatus: message.actionable.offer_status,
          buyerOffer: message.actionable.buyer_offer,
          sellerOffer: message.actionable.seller_offer,
          offerCategory: message.actionable.offer_category
        };
      }
      return null;
    }
  }, {
    key: "getMeetingPayload",
    value: function getMeetingPayload(message) {
      if (message && message.actionable) {
        return {
          appointmentId: message.actionable.appointment_id,
          bookingId: message.actionable.booking_id,
          cancelledBy: message.actionable.cancelled_by,
          date: message.actionable.date,
          location: message.actionable.location,
          meetingStatus: message.actionable.meeting_status,
          requestedBy: message.actionable.requested_by,
          phoneNumber: message.actionable.phone_number,
          time: message.actionable.time,
          endTime: message.actionable.end_time,
          type: message.actionable.subType,
          meetingDetails: {
            appointmentId: message.actionable.appointment_id,
            bookingId: message.actionable.booking_id,
            cancelledBy: message.actionable.cancelled_by,
            date: message.actionable.date,
            location: message.actionable.location,
            status: message.actionable.meeting_status,
            requestedBy: message.actionable.requested_by,
            phoneNumber: message.actionable.phone_number,
            time: message.actionable.time,
            endTime: message.actionable.end_time,
            type: message.actionable.subType
          }
        };
      }
      return null;
    }
  }, {
    key: "getLeadInfoPayload",
    value: function getLeadInfoPayload(message) {
      var _message$leadInfo;
      var leadInfo = (_message$leadInfo = message === null || message === void 0 ? void 0 : message.leadInfo) !== null && _message$leadInfo !== void 0 ? _message$leadInfo : message === null || message === void 0 ? void 0 : message.lead_info;
      if (message && !(0, _objects.isEmpty)(leadInfo)) {
        return {
          leadInfo: {
            email: leadInfo.email,
            leadFormType: leadInfo.leadFormType,
            name: leadInfo.name,
            phone: leadInfo.phone,
            leadId: leadInfo.leadId
          }
        };
      }
      return null;
    }
  }, {
    key: "saveMessage",
    value: function saveMessage(message) {
      var _this18 = this;
      var received = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var date = message && message.delay && message.delay.stamp && message.delay.stamp.getTime() || new Date().getTime();
      date = message && message.forwarded && message.forwarded.delay && message.forwarded.delay.stamp && message.forwarded.delay.stamp.getTime() || date;

      // Ignore welcome message stanza
      if (message && message.system && (message.system.layout === 'layout_welcome_coco' || message.system.layout === 'layout_welcome_fofo')) {
        return Promise.resolve();
      }
      if (message.displayed || message.received) {
        return Promise.resolve();
      }
      if ((0, _typeof2.default)(message.intervention) === 'object') {
        this.saveIntervention(message, date);
        return Promise.reject();
      }
      if ((0, _typeof2.default)(message.suggestion) === 'object') {
        this.saveSuggestions(message.suggestion);
        return Promise.resolve();
      }
      if ((0, _typeof2.default)(message.actionSuggestions) === 'object') {
        this.saveActionSuggestions(message.actionSuggestions);
        return Promise.resolve();
      }
      if (!this.isMessage(message)) {
        return Promise.reject();
      }
      var id = message.id;
      if (typeof id === 'undefined') {
        return Promise.reject();
      }
      var old;
      var dbMessage = chatDb.getNewMessage();
      dbMessage.id = id;
      dbMessage.body = message.body;
      dbMessage.itemId = message.extras ? message.extras.itemId : null;
      dbMessage.from = this.removeCountryCode(message.from.local);
      dbMessage.to = this.removeCountryCode(message.to.local);
      dbMessage.date = date;
      dbMessage.updatedAt = date;
      dbMessage.isMine = this.removeCountryCode(message.from.local) === this.user.id;
      dbMessage.userId = dbMessage.isMine ? this.removeCountryCode(message.to.local) : this.removeCountryCode(message.from.local);
      dbMessage.location = (0, _typeof2.default)(message.location) === 'object' && message.location;
      dbMessage.image = (0, _typeof2.default)(message.image) === 'object' && message.image;
      dbMessage.voice = (0, _typeof2.default)(message.voice) === 'object' && message.voice;
      dbMessage.info = (0, _typeof2.default)(message.info) === 'object';
      dbMessage.sms = (0, _typeof2.default)(message.sms) === 'object';
      dbMessage.call = (0, _typeof2.default)(message.call) === 'object';
      dbMessage.escrowInterest = (0, _typeof2.default)(message.escrowInterest) === 'object';
      dbMessage.escrowEnabled = (0, _typeof2.default)(message.escrowEnabled) === 'object';
      dbMessage.actionable = (0, _typeof2.default)(message.actionable) === 'object' && message.actionable;
      dbMessage.autoReply = message.auto_reply && (0, _typeof2.default)(message.auto_reply) === 'object';
      dbMessage.replyTo = (0, _typeof2.default)(message.reply_to) === 'object' && message.reply_to;
      dbMessage.tipTo = (0, _typeof2.default)(message.tip_to) === 'object' && message.tip_to;
      dbMessage.type = message.type;
      dbMessage.system = (0, _typeof2.default)(message.system) === 'object' && message.system;
      dbMessage.userItemId = "".concat(dbMessage.userId, "_").concat(dbMessage.itemId);
      dbMessage.leadInfo = (0, _typeof2.default)(message.lead_info) === 'object' && message.lead_info;
      dbMessage.categoryId = message.extras ? message.extras.categoryId : null;
      dbMessage.dealerType = message.extras ? message.extras.dealerType : null;
      dbMessage.buyerId = message.extras ? message.extras.buyerId : null;
      dbMessage.sellerId = message.extras ? message.extras.sellerId : null;
      if (dbMessage.tipTo && dbMessage.system) {
        return this.setTipForMessage(dbMessage.tipTo.msgId, dbMessage.system);
      }
      if (dbMessage.dealerType) {
        this.setCategoryId(dbMessage.userId, dbMessage.itemId, {
          categoryId: message.extras.categoryId
        });
        this.setDealerType(dbMessage.userId, dbMessage.itemId, {
          dealerType: message.extras.dealerType
        });
      }
      if (dbMessage.sellerId) {
        this.setSellerId(dbMessage.userId, dbMessage.itemId, {
          sellerId: message.extras.sellerId
        });
      }
      if ((0, _typeof2.default)(message.lead_info) === 'object') {
        this.setLeadInfo(dbMessage.userId, dbMessage.itemId, this.getLeadInfoPayload(message));
      }
      if ((0, _typeof2.default)(message.actionable) === 'object') {
        if (message.actionable.subType === 'phone_request') {
          this.setPhoneRequestStatus(dbMessage.userId, dbMessage.itemId, message.actionable && message.actionable.phone_request_status);
          if (!dbMessage.isMine && message.actionable.phone_request_status === 'accepted' && message.actionable.phone_number) {
            this.setPhoneNumberForThread(dbMessage.userId, dbMessage.itemId, message.actionable && message.actionable.phone_number);
          }
        } else if (message.actionable.subType === 'offer') {
          this.setOfferStatus(dbMessage.userId, dbMessage.itemId, this.getOfferPayload(message));
        } else if ([_constants.MEETING_TYPE.STORE, _constants.MEETING_TYPE.HOME_STORE, _constants.MEETING_TYPE.STORE_VISIT].indexOf(message.actionable.subType) > -1) {
          this.setMeeting(dbMessage.userId, dbMessage.itemId, this.getMeetingPayload(message));
        }
      }
      if ((0, _typeof2.default)(message.reply_to) === 'object' && !(0, _objects.isEmpty)(message.reply_to)) {
        this.markMessageAsReplied(message);
      }
      return this.messageHasThread(dbMessage).then(function (hasThread) {
        if (!hasThread) {
          var thread = _this18.formatThread(dbMessage);
          if (thread) {
            // event emitted for KYC Reply Restriction counter to sync across platforms
            _ChatEventsEmitter.ChatEventsEmitter.dispatch('incrementKycReplyCount', thread.itemId, thread.userId);
            chatDb.addThread(thread);
          } else {
            return null;
          }
        }
        return chatDb.getMessageById(id, function (msg) {
          old = msg;
          if (typeof old === 'undefined') {
            dbMessage.received = received;
            if (received) {
              _this18.saveLatestMsgDate(dbMessage);
            }
            chatDb.addMessage(dbMessage).catch(function (e) {
              if (e && e.message && e.message.indexOf('Quota') !== -1) {
                _this18.logMessageSaveError(e, 'chat_send_message_save_failed');
              }
            });
            if (typeof old === 'undefined') {
              var otherUser = message.from.local === _this18.addCountryCode(_this18.user.id) ? message.to.local : message.from.local;
              if (otherUser === _this18.addCountryCode(_this18.user.id)) {
                return null;
              }
              return _this18.saveUser(_this18.removeCountryCode(otherUser));
            }
            return Promise.resolve();
          } else if (!(0, _objects.isEmpty)(message.actionable)) {
            chatDb.addMessage(dbMessage).catch(function (e) {
              if (e && e.message && e.message.indexOf('Quota') !== -1) {
                _this18.logMessageSaveError(e, 'chat_send_message_save_failed');
              }
            });
            return Promise.resolve();
          }
          dbMessage.date = date;
          dbMessage.updatedAt = date;
          chatDb.addMessage(dbMessage).catch(function (e) {
            if (e && e.message && e.message.indexOf('Quota') !== -1) {
              _this18.logMessageSaveError(e, 'chat_send_message_save_failed');
            }
          });
          return null;
        });
      });
    }
  }, {
    key: "saveHttpMessages",
    value: function saveHttpMessages(messages, callback) {
      var _this19 = this;
      try {
        var messagesTo = messages.map(function (message) {
          return _this19.formatHttpMessage(message);
        });
        var saveMessageOperation = this.saveHttpMessageList(messagesTo);
        return saveMessageOperation.then(function (status) {
          _this19.client.emit('messages:received');
          if (status) {
            return callback();
          }
          return null;
        });
      } catch (e) {
        if (e && e.message && e.message.indexOf('Quota') !== -1) {
          this.logMessageSaveError(e, 'chat_api_message_save_failed');
        }
        return null;
      }
    }
  }, {
    key: "saveHttpThreads",
    value: function saveHttpThreads(threads, callback) {
      var _this20 = this;
      try {
        var threadsTo = threads.reduce(function (filteredThreads, thread) {
          var threadInfo = _this20.formatHttpThread(thread);
          if (threadInfo) {
            filteredThreads.push(threadInfo);
          }
          return filteredThreads;
        }, []);
        var saveThreadOperation = this.saveHttpThreadList(threadsTo);
        return saveThreadOperation.then(function (status) {
          _this20.client.emit('messages:received');
          if (status) {
            return callback(null);
          }
          return callback('chat_api_all_thread_save_failed');
        });
      } catch (e) {
        return callback(e);
      }
    }
  }, {
    key: "fetchThreadData",
    value: function fetchThreadData(threads, callback) {
      var _this21 = this;
      this.requestQueue = [];
      var queueLength = this.config && this.config.queueLength || QUEUE_LENGTH;
      var bulkMessagesQueryParams = [];
      threads.forEach(function (thread, index) {
        bulkMessagesQueryParams.push({
          peer_id: parseInt(thread.peer_id, 10),
          ad_id: parseInt(thread.ad_id, 10),
          time: 0
        });
        if ((index + 1) % queueLength === 0 || index + 1 === threads.length) {
          _this21.requestQueue.push(_this21.preFetchMessagesByThread(bulkMessagesQueryParams));
          bulkMessagesQueryParams = [];
        }
      });
      return this.runThreadsQueue(callback);
    }
  }, {
    key: "runThreadsQueue",
    value: function runThreadsQueue(callback) {
      var _this22 = this;
      this.runningQueue = [];
      if (this.requestQueue.length) {
        this.runningQueue.push(this.requestQueue[0]());
        return Promise.all(this.runningQueue).then(function () {
          _this22.runningQueue = [];
          _this22.requestQueue.splice(0, 1);
          _this22.runThreadsQueue(callback);
        }).catch(function () {
          _this22.runningQueue = [];
          _this22.requestQueue.splice(0, 1);
          _this22.runThreadsQueue(callback);
        });
      }
      return callback();
    }
  }, {
    key: "removeHttpMessages",
    value: function removeHttpMessages(messages) {
      messages.forEach(function (message) {
        return chatDb.removeMessageBySync(message.msg_id);
      });
    }
  }, {
    key: "formatHttpMessage",
    value: function formatHttpMessage(message) {
      var id = message.msg_id;
      if (!this.isHttpMessage(message) || typeof id === 'undefined' || message.type === 'intervention') {
        return null;
      }
      if (message.type === 'system') {
        message.type_data = this.alterSystemMessage(message.type_data);
      }
      var dbMessage = chatDb.getNewMessage();
      dbMessage.id = id;
      dbMessage.body = message.text;
      dbMessage.itemId = message.ad_id;
      dbMessage.from = message.sender_id;
      dbMessage.to = message.receiver_id;
      dbMessage.date = parseInt(message.timestamp, 10);
      dbMessage.updatedAt = parseInt(message.updated_at, 10);
      dbMessage.isMine = message.sender_id === this.user.id;
      dbMessage.userId = dbMessage.isMine ? message.receiver_id : message.sender_id;
      dbMessage.location = message.type === 'location' && message.type_data;
      dbMessage.image = message.type === 'image' && message.type_data;
      dbMessage.voice = message.type === 'voice' && message.type_data;
      dbMessage.info = message.type === 'info';
      dbMessage.sms = message.type === 'sms';
      dbMessage.call = message.type === 'call';
      dbMessage.escrowInterest = message.type === 'escrowInterest';
      dbMessage.escrowEnabled = message.type === 'escrowEnabled';
      dbMessage.actionable = message.type === 'actionable' && message.type_data;
      dbMessage.type = 'chat';
      dbMessage.system = message.type === 'system' && message.type_data;
      dbMessage.suggestions = message.suggestions || message.actionable_suggestions;
      dbMessage.hasReplied = message.replied;
      dbMessage.autoReply = message.auto_reply;
      dbMessage.replyTo = message.reply_to && this.formatReplyTo(message.reply_to);
      dbMessage.displayed = message.status === 'displayed';
      dbMessage.received = message.status === 'received';
      dbMessage.userItemId = "".concat(dbMessage.userId, "_").concat(dbMessage.itemId);
      dbMessage.categoryId = message.category_id;
      dbMessage.dealerType = message.dealer_type;
      dbMessage.buyerId = message.buyer_id;
      dbMessage.sellerId = message.seller_id;
      if (message.tip_to) {
        if (message.type === 'system') {
          dbMessage.tipTo = message.tip_to;
        } else {
          dbMessage.systemMessageData = {
            messageId: message.tip_to.tip_msg_id,
            id: message.tip_to.tip_id
          };
        }
      }
      var msg = chatDb.getMessageDataById(id);
      if (typeof msg === 'undefined') {
        if (dbMessage.to === this.user.id && !dbMessage.displayed && !dbMessage.received) {
          this.sendReceived(dbMessage);
          dbMessage.received = true;
        }
        this.saveLatestMsgDate(dbMessage);
        var otherUser = dbMessage.from === this.user.id ? dbMessage.to : dbMessage.from;
        if (otherUser !== this.user.id) {
          this.saveUser(otherUser);
        }
        return dbMessage;
      } else if (msg && !msg.displayed && dbMessage.displayed) {
        this.markDisplayed(id);
      } else if (msg && !msg.received && dbMessage.received) {
        this.markReceived(id);
      }
      if (msg && msg.received && !dbMessage.received) {
        dbMessage.received = msg.received;
      } else if (msg && msg.displayed && !dbMessage.displayed) {
        dbMessage.displayed = msg.displayed;
      }
      return dbMessage;
    }
  }, {
    key: "formatReplyTo",
    value: function formatReplyTo(message) {
      var newMessage = {};
      newMessage.id = message.id;
      newMessage.body = message.body;
      newMessage.itemId = message.ad_id;
      newMessage.from = message.sender_id;
      newMessage.to = message.receiver_id;
      newMessage.date = parseInt(message.timestamp, 10);
      newMessage.isMine = message.sender_id === this.user.id;
      newMessage.userId = newMessage.isMine ? message.receiver_id : message.sender_id;
      newMessage.location = message.type === 'location' && message.type_data;
      newMessage.image = message.type === 'image' && message.type_data;
      newMessage.voice = message.type === 'voice' && message.type_data;
      newMessage.actionable = message.type === 'actionable' && message.type_data;
      newMessage.type = 'chat';
      newMessage.userItemId = "".concat(message.userId, "_").concat(message.itemId);
      return newMessage;
    }
  }, {
    key: "getMessagesByThread",
    value: function getMessagesByThread(peerId, itemId) {
      var _arguments3 = arguments,
        _this23 = this;
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      return (0, _XHR.getThreadMessages)(page, time, this.config.myChatsApi, this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN), peerId, itemId).then(function (res) {
        var messages = res.data;
        if (res.error === 'invalid') {
          if (_this23.getJWTCount < _this23.config.retryTrail) {
            _this23.getJWTCount++;
            _this23.getJwtToken();
            _this23.retryRequest(_this23.getMessagesByThread, _arguments3);
          }
          return null;
        } else if (messages && messages.length) {
          _this23.saveMessages(messages, peerId, itemId);
        }
        _this23.getJWTCount = 0;
        return null;
      });
    }
  }, {
    key: "getBulkMessages",
    value: function getBulkMessages(queryParams) {
      var _arguments4 = arguments,
        _this24 = this;
      return (0, _XHR.getBulkThreadMessages)(this.config.myChatsApi, this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN), (0, _toConsumableArray2.default)(queryParams)).then(function (res) {
        var bulkMessages = res.data;
        if (res.error === 'invalid') {
          if (_this24.getJWTCount < _this24.config.retryTrail) {
            _this24.getJWTCount++;
            _this24.getJwtToken();
            _this24.retryRequest(_this24.getBulkMessages, _arguments4);
          }
          return null;
        } else if (bulkMessages && bulkMessages.length) {
          bulkMessages.forEach(function (item) {
            _this24.saveMessages(item.messages, item.peer_id, item.ad_id);
          });
        }
        _this24.getJWTCount = 0;
        return null;
      });
    }

    /**
     * Is REsponsible for making and XHR call to fetch Questions API and then store the
     * @param {*} userId
     * @param {*} itemId
     * @param {*} categoryId
     * @param {*} senderType
     */
  }, {
    key: "fetchQuestionsForThread",
    value: function fetchQuestionsForThread(userId, itemId, categoryId, senderType) {
      var _this25 = this;
      var _this$config3 = this.config,
        APIDomain = _this$config3.APIDomain,
        questionsApi = _this$config3.questionsApi;
      var completeAPI = "".concat(APIDomain).concat(questionsApi);
      return (0, _XHR.fetchQuestions)(completeAPI, this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN), userId, itemId, categoryId, senderType).then(function (result) {
        if (result.error || !result.data || !result.data.length) {
          throw new Error();
        }
        var segmentedQuestions = _this25.segmentQuestions(result.data, senderType);
        return _this25.saveQuestions(userId, itemId, segmentedQuestions);
      }).catch(function () {});
    }
  }, {
    key: "saveMessages",
    value: function saveMessages(messages, peerId, itemId) {
      var _this26 = this;
      if (messages.length) {
        var newMessages = [];
        var deletedMessages = [];
        messages.forEach(function (message) {
          // filter out welcome message
          if (message.type_data && (message.type_data.layout === 'layout_welcome_coco' || message.type_data.layout === 'layout_welcome_fofo')) {
            return;
          }
          if (message.deleted) {
            deletedMessages.push(message);
          } else {
            newMessages.push(message);
          }
        });
        this.removeHttpMessages(deletedMessages);
        return this.saveHttpMessages(newMessages, function () {
          _this26.didLoadMessagesForThread(peerId, itemId);
          _this26.setUpdateForThread(peerId, itemId);
        });
      }
      return chatDb.removeThread(peerId, itemId);
    }

    /**
     * Calls the database functions to add the segmentedQuestions
     * @param {*} userId
     * @param {*} itemId
     * @param {*} segmentedQuestions
     */
  }, {
    key: "saveQuestions",
    value: function saveQuestions(userId, itemId, segmentedQuestions) {
      try {
        return chatDb.addQuestions(userId, itemId, segmentedQuestions);
      } catch (e) {
        if (e && e.message && e.message.indexOf('Quota') !== -1) {
          this.logMessageSaveError(e, 'questions_api_save_failed');
        }
        return null;
      }
    }

    /**
     * This function is used as a Array.reduce callback function
     * the transformedQuestionsArr holds the valid and transformed questions(accumulator)
     * @param {*} transformedQuestionsArr
     * @param {*} question
     */
  }, {
    key: "formatQuestionObject",
    value: function formatQuestionObject(transformedQuestionsArr) {
      var question = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var questionText = question.question_text,
        questionId = question.question_id,
        relatedAdParam = question.related_ad_param,
        subTopicDisplay = question.sub_topic_display,
        subtopic = question.subtopic,
        rest = (0, _objectWithoutProperties2.default)(question, _excluded);
      if (!subtopic && !subTopicDisplay) {
        return transformedQuestionsArr;
      }
      transformedQuestionsArr.push(_objectSpread({
        questionText: questionText,
        questionId: questionId,
        subTopicDisplay: subTopicDisplay || rest.subtopic,
        subtopic: subtopic,
        relatedAdParam: relatedAdParam
      }, rest));
      return transformedQuestionsArr;
    }
  }, {
    key: "segmentQuestions",
    value:
    /**
     * Groups the questions in the array in to different `subtopic`s
     * Also make extracts the popular section after sorting on priority basis
     * @param {*} questionsArr
     */
    function segmentQuestions(questionsArr, senderType) {
      var filteredQuestions = this.filterSenderTypeQuestions(questionsArr, senderType);
      var intermediateArr = [];
      var indexMapper = {};
      var sortedQuestions = filteredQuestions.reduce(this.formatQuestionObject, []) // responsible for filtering out questions objects not having subtopic & subtopicDisplay keys
      .sort(function (a, b) {
        return a.priority - b.priority;
      });
      var popularQuestionsCount = this.config.popularQuestionsCount;
      var popularQuestions = sortedQuestions.slice(0, popularQuestionsCount);
      var popularSegment = {
        count: popularQuestionsCount,
        id: 'popular',
        title: 'Popular',
        questions: popularQuestions
      };
      var _iterator = _createForOfIteratorHelper(sortedQuestions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var question = _step.value;
          var subtopic = question.subtopic,
            subTopicDisplay = question.subTopicDisplay;
          if (subtopic in indexMapper) {
            var index = indexMapper[subtopic];
            intermediateArr[index].count++;
            intermediateArr[index].questions.push(question);
          } else {
            indexMapper[subtopic] = intermediateArr.length;
            intermediateArr.push({
              count: 1,
              id: subtopic,
              title: subTopicDisplay,
              questions: [question]
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return [popularSegment].concat((0, _toConsumableArray2.default)(intermediateArr.sort(function (a, b) {
        return b.count - a.count;
      })));
    }
  }, {
    key: "formatHttpThread",
    value: function formatHttpThread(thread) {
      var _thread$meeting_detai, _thread$meeting_detai2, _thread$meeting_detai3, _thread$meeting_detai4, _thread$meeting_detai5, _thread$meeting_detai6, _thread$meeting_detai7, _thread$meeting_detai8, _thread$meeting_detai9;
      var dbThread = {};
      dbThread.userId = thread.peer_id;
      dbThread.itemId = thread.ad_id;
      dbThread.id = "".concat(dbThread.userId, "_").concat(dbThread.itemId);
      dbThread.lastMsgTimestamp = parseInt(thread.last_msg_timestamp, 10);
      dbThread.bNeedsUpdate = thread.bNeedsUpdate;
      dbThread.myUserId = this.user.id;
      dbThread.expiresOn = Number(thread.expires_on);
      dbThread.adStatus = thread.ad_status;
      dbThread.userStatus = thread.peer_status;
      dbThread.phoneRequestStatus = thread.phone_request_status;
      dbThread.phoneNumber = thread.phonenumber;
      dbThread.important = thread.tag === 'important';
      dbThread.buyerOffer = thread.buyer_offer;
      dbThread.sellerOffer = thread.seller_offer;
      dbThread.offerId = thread.offer_id;
      dbThread.offerStatus = thread.offer_status;
      dbThread.offerCategory = thread.offer_category;
      dbThread.appointmentId = (_thread$meeting_detai = thread.meeting_details) === null || _thread$meeting_detai === void 0 ? void 0 : _thread$meeting_detai.appointment_id;
      dbThread.bookingId = (_thread$meeting_detai2 = thread.meeting_details) === null || _thread$meeting_detai2 === void 0 ? void 0 : _thread$meeting_detai2.booking_id;
      dbThread.cancelledBy = (_thread$meeting_detai3 = thread.meeting_details) === null || _thread$meeting_detai3 === void 0 ? void 0 : _thread$meeting_detai3.cancelled_by;
      dbThread.date = (_thread$meeting_detai4 = thread.meeting_details) === null || _thread$meeting_detai4 === void 0 ? void 0 : _thread$meeting_detai4.date;
      dbThread.location = (_thread$meeting_detai5 = thread.meeting_details) === null || _thread$meeting_detai5 === void 0 ? void 0 : _thread$meeting_detai5.location;
      dbThread.meetingStatus = (_thread$meeting_detai6 = thread.meeting_details) === null || _thread$meeting_detai6 === void 0 ? void 0 : _thread$meeting_detai6.status;
      dbThread.requestedBy = (_thread$meeting_detai7 = thread.meeting_details) === null || _thread$meeting_detai7 === void 0 ? void 0 : _thread$meeting_detai7.requested_by;
      dbThread.time = (_thread$meeting_detai8 = thread.meeting_details) === null || _thread$meeting_detai8 === void 0 ? void 0 : _thread$meeting_detai8.time;
      dbThread.endTime = thread.meeting_end_time;
      dbThread.creationSource = thread.creation_source;
      dbThread.appKey = thread.app_key;
      dbThread.type = (_thread$meeting_detai9 = thread.meeting_details) === null || _thread$meeting_detai9 === void 0 ? void 0 : _thread$meeting_detai9.type;
      dbThread.meetingDetails = thread.meeting_details;
      dbThread.leadInfo = thread.lead_info;
      dbThread.dealerType = thread.dealer_type;
      dbThread.categoryId = thread.category_id;
      if (isNaN(dbThread.lastMsgTimestamp)) {
        return undefined;
      }
      return dbThread;
    }
  }, {
    key: "didLoadMessagesForThread",
    value: function didLoadMessagesForThread(peerId, itemId) {
      return this.updateThread(peerId, itemId, {
        bDidLoadMessages: true
      });
    }
  }, {
    key: "setUpdateForThread",
    value: function setUpdateForThread(peerId, itemId) {
      return this.updateThread(peerId, itemId, {
        bNeedsUpdate: false
      });
    }
  }, {
    key: "setPhoneRequestStatus",
    value: function setPhoneRequestStatus(peerId, itemId, phoneRequestStatus) {
      return this.updateThread(peerId, itemId, {
        phoneRequestStatus: phoneRequestStatus
      });
    }
  }, {
    key: "setPhoneNumberForThread",
    value: function setPhoneNumberForThread(peerId, itemId, phoneNumber) {
      return this.updateThread(peerId, itemId, {
        phoneNumber: phoneNumber
      });
    }
  }, {
    key: "setOfferStatus",
    value: function setOfferStatus(peerId, itemId, _ref8) {
      var offerStatus = _ref8.offerStatus,
        offerId = _ref8.offerId,
        buyerOffer = _ref8.buyerOffer,
        sellerOffer = _ref8.sellerOffer,
        offerCategory = _ref8.offerCategory;
      return this.updateThread(peerId, itemId, {
        offerStatus: offerStatus,
        offerId: offerId,
        buyerOffer: buyerOffer,
        sellerOffer: sellerOffer,
        offerCategory: offerCategory
      });
    }
  }, {
    key: "setMeeting",
    value: function setMeeting(peerId, itemId, meeting) {
      this.updateThread(peerId, itemId, meeting);
    }
  }, {
    key: "updateThread",
    value: function updateThread(peerId, itemId, updates) {
      return chatDb.updateThread("".concat(peerId, "_").concat(itemId), updates);
    }
  }, {
    key: "addMessageSuggestion",
    value: function addMessageSuggestion(msgId, suggestions, callback) {
      return chatDb.addSuggestions(msgId, suggestions, callback);
    }
  }, {
    key: "setTipForMessage",
    value: function setTipForMessage(msgId, systemMessage) {
      return chatDb.setTipForMessage(msgId, systemMessage);
    }
  }, {
    key: "setLeadInfo",
    value: function setLeadInfo(peerId, itemId, leadInfo) {
      this.updateThread(peerId, itemId, leadInfo);
    }
  }, {
    key: "setCategoryId",
    value: function setCategoryId(peerId, itemId, categoryId) {
      this.updateThread(peerId, itemId, categoryId);
    }
  }, {
    key: "setDealerType",
    value: function setDealerType(peerId, itemId, dealerType) {
      this.updateThread(peerId, itemId, dealerType);
    }
  }, {
    key: "setSellerId",
    value: function setSellerId(peerId, itemId, sellerId) {
      this.updateThread(peerId, itemId, sellerId);
    }
  }, {
    key: "formatThread",
    value: function formatThread(message) {
      var dbThread = {};
      dbThread.userId = message.userId;
      dbThread.itemId = message.itemId;
      dbThread.id = "".concat(dbThread.userId, "_").concat(dbThread.itemId);
      dbThread.lastMsgTimestamp = parseInt(message.date, 10);
      dbThread.myUserId = this.user.id;
      dbThread.adStatus = message.ad_status;
      dbThread.userStatus = message.peer_status;
      dbThread.expiresOn = null;
      dbThread.buyerOffer = null;
      dbThread.sellerOffer = null;
      dbThread.offerId = null;
      dbThread.offerStatus = null;
      dbThread.phoneRequestStatus = null;
      dbThread.phoneNumber = null;
      dbThread.dealerType = message.dealerType;
      dbThread.categoryId = message.categoryId;
      dbThread.sellerId = message.sellerId;
      dbThread.buyerId = message.buyerId;
      if (message.actionable) {
        if (message.actionable.subType === 'phone_request') {
          dbThread.phoneRequestStatus = message.actionable.phone_request_status;
          dbThread.phoneNumber = message.actionable.phone_number;
        } else if (message.actionable.subType === 'offer') {
          Object.assign(dbThread, this.getOfferPayload(message));
        } else if ([_constants.MEETING_TYPE.STORE, _constants.MEETING_TYPE.HOME_STORE, _constants.MEETING_TYPE.STORE_VISIT].indexOf(message.actionable.subType) > -1) {
          Object.assign(dbThread, this.getMeetingPayload(message));
        }
      }
      if (message.leadInfo) {
        Object.assign(dbThread, this.getLeadInfoPayload(message));
      }
      if (isNaN(dbThread.lastMsgTimestamp)) {
        return undefined;
      }
      return dbThread;
    }
  }, {
    key: "saveHttpMessageList",
    value: function saveHttpMessageList(messages) {
      var _this27 = this;
      var promiseArr = chatDb.addMessages(messages);
      return Promise.all(promiseArr).then(function (status) {
        return !!(status && status.length && status[status.length - 1]);
      }).catch(function (e) {
        if (e && e.message && e.message.indexOf('Quota') !== -1) {
          _this27.logMessageSaveError(e, 'chat_api_message_save_failed');
        }
        return false;
      });
    }
  }, {
    key: "saveHttpThreadList",
    value: function saveHttpThreadList(messages) {
      var _this28 = this;
      var promiseArr = chatDb.addThreads(messages);
      return Promise.all(promiseArr).then(function (status) {
        return !!(status && status.length && status[status.length - 1]);
      }).catch(function (e) {
        if (e && e.message && e.message.indexOf('Quota') !== -1) {
          _this28.logMessageSaveError(e, 'chat_api_message_save_failed');
        }
        return false;
      });
    }

    // eslint-disable-next-line handle-callback-err, no-unused-vars
  }, {
    key: "logMessageSaveError",
    value: function logMessageSaveError(error, event) {
      if ('storage' in window.navigator && 'estimate' in window.navigator.storage) {
        // eslint-disable-next-line handle-callback-err, no-unused-vars
        window.navigator.storage.estimate().then(function (_ref9) {
          var usage = _ref9.usage,
            quota = _ref9.quota;
        } // window.newrelic?.addPageAction(event, {
        //     user_id: this.user.id,
        //     error,
        //     usage,
        //     quota
        // });
        ).catch(function () {});
      } else {
        // window.newrelic?.addPageAction(event, {
        //     user_id: this.user.id,
        //     error
        // });
      }
    }
  }, {
    key: "alterSystemMessage",
    value: function alterSystemMessage(data) {
      var typeData = data;
      if (data.action_label) {
        typeData.actionLabel = data.action_label;
        delete typeData.action_label;
      }
      if (data.layout === 'layout_item_deeplink') {
        var obj = JSON.parse(data.deeplinks);
        typeData.deeplinks = {
          deeplink: obj.deeplinks[0]
        };
      }
      return typeData;
    }
  }, {
    key: "saveLatestMsgDate",
    value: function saveLatestMsgDate(msg) {
      var isMine = msg.isMine;
      var userId = isMine ? msg.to : msg.from;
      this.latestMsgObj[userId] = this.latestMsgObj[userId] || {};
      this.latestMsgObj[userId][isMine ? 'sent' : 'received'] = msg.date;
    }
  }, {
    key: "saveUser",
    value: function saveUser(userId) {
      var _this29 = this;
      return chatDb.getUser(userId, function (oldUser) {
        if (typeof oldUser === 'undefined') {
          return chatDb.addUser({
            id: userId,
            presence: _this29.userPresence[userId] || 'unavailable',
            isBlock: _this29.blockList.includes(_this29.addCountryCode(userId))
          });
        }
        return null;
      });
    }
  }, {
    key: "sendThreadOpenEvent",
    value: function sendThreadOpenEvent(itemId, userId, id) {
      this.client.sendIq({
        type: 'set',
        event: {
          name: 'chat_window_open',
          to: this.addFullCode(userId),
          itemId: itemId,
          senderType: id === this.user.id ? 'seller' : 'buyer'
        },
        from: this.addFullCode(this.user.id)
      });
    }
  }, {
    key: "subscribeAndAccept",
    value: function subscribeAndAccept(userId) {
      this.subscribe(userId);
      this.acceptSubscription(userId);
    }
  }, {
    key: "blockUser",
    value: function blockUser(userId) {
      var id = this.addFullCode(userId);
      this.sendPresenceToUser('unavailable', id);
      return this.client.block(id);
    }
  }, {
    key: "unblockUser",
    value: function unblockUser(userId) {
      var _this30 = this;
      var id = this.addFullCode(userId);
      return this.client.unblock(id, function () {
        _this30.sendPresenceToUser('available', id);
      });
    }
  }, {
    key: "deleteChat",
    value: function deleteChat(userId, itemId) {
      return this.client.sendIq({
        type: 'set',
        deleteChat: {
          jid: this.addFullCode(userId),
          adid: itemId
        }
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(userId) {
      this.client.subscribe(this.addFullCode(userId));
    }
  }, {
    key: "acceptSubscription",
    value: function acceptSubscription(userId) {
      this.client.acceptSubscription(this.addFullCode(userId));
    }
  }, {
    key: "sendPresence",
    value: function sendPresence(type) {
      if (!this.connEstablished) {
        return;
      }
      if (type === 'idle') {
        this.client.sendPresence({
          idle: {
            since: new Date().toISOString()
          }
        });
      } else {
        this.client.sendPresence({
          type: type
        });
      }
    }
  }, {
    key: "sendPresenceToUser",
    value: function sendPresenceToUser(type, to) {
      if (!this.connEstablished) {
        return;
      }
      this.client.sendPresence({
        type: type,
        to: to
      });
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.obj && this.obj.password) {
        this.client.connect(this.obj);
      }
    }
  }, {
    key: "resetUserPresence",
    value: function resetUserPresence() {
      return chatDb.resetUserPresence(this.user.id);
    }
  }, {
    key: "searchMessages",
    value: function searchMessages(text) {
      return chatDb.searchMessages(text);
    }
  }, {
    key: "markThreadAsImportant",
    value: function markThreadAsImportant(peer_id, ad_id, bIsImportant) {
      var _this31 = this;
      var token = this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN);
      var queryParams = {
        ad_id: ad_id,
        peer_id: peer_id,
        tag: bIsImportant ? 'important' : ''
      };
      return (0, _XHR.markThreadAsImportant)("".concat(this.config.APIDomain).concat(this.config.markImportantAPI), token, queryParams).then(function (markImportant) {
        if (markImportant) {
          _this31.updateThreadAsImportant(peer_id, ad_id, bIsImportant);
        }
      }).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (e) {
        // window.newrelic?.addPageAction('error_in_mark_important_api', {
        //     e
        // });
      });
    }
  }, {
    key: "postNumber",
    value: function postNumber(user_id, ad_id, name, phone) {
      var token = this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN);
      var queryParams = {
        ad_id: ad_id,
        user_id: user_id,
        name: name,
        phone: phone
      };
      return (0, _XHR.postNumber)("".concat(this.config.APIDomain).concat(this.config.postNumberAPI), token, queryParams).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (e) {
        // window.newrelic?.addPageAction('error_in_post_number_api', {
        //     e
        // });
      });
    }
  }, {
    key: "getPricingDetails",
    value: function getPricingDetails(ad_id) {
      var token = this.getStorageItem(_xmpp.BIFROST_JWT_TOKEN);
      return (0, _XHR.getPricingDetails)("".concat(this.config.APIDomain).concat(this.config.pricingAPI), token, ad_id).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (e) {
        // window.newrelic?.addPageAction('error_in_pricing_api', {
        //     e
        // });
      });
    }
  }, {
    key: "updateThreadAsImportant",
    value: function updateThreadAsImportant(peerId, itemId, bIsImportant) {
      return this.updateThread(peerId, itemId, {
        important: bIsImportant
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.client) {
        clearInterval(this.timeout);
        this.sendPresence('unavailable');
        this.retryTrail = 0;
        this.client.disconnect();
        if (val) {
          this.latestMsgObj = {};
          this.client = null;
          interventionDb.clear();
          return this.cleanDb();
        }
        this.resetUserPresence();
      }
      return null;
    }
  }, {
    key: "cleanDb",
    value: function cleanDb() {
      return chatDb.cleanDb().then(function () {
        chatDb = undefined;
      }).catch(function () {});
    }
  }], [{
    key: "createStanzaClient",
    value: function createStanzaClient(params) {
      var client = new _client.default(params);
      client.use(require('stanza.io/lib/plugins/disco'));
      client.use(require('stanza.io/lib/plugins/carbons'));
      client.use(require('stanza.io/lib/plugins/roster'));
      client.use(require('stanza.io/lib/plugins/smacks'));
      client.use(require('stanza.io/lib/plugins/blocking'));
      return client;
    }
  }]);
  return XMPPClient;
}();
function saveInterventionsData(store, obj) {
  interventionDb.saveInterventionsData(obj).then(function (data) {
    storeAction.saveInterventionsData(store, data);
  }).catch(function () {});
}
function saveSystemMessageData(store, obj) {
  interventionDb.saveSystemMessageData(obj).then(function (data) {
    storeAction.saveSystemMessageData(store, data);
  }).catch(function () {});
}
var _default = exports.default = function _default(store) {
  var instance = null;
  var savedConfig = null;
  return {
    instanceExists: function instanceExists() {
      return instance !== null && instance.client !== null;
    },
    getConfig: function getConfig() {
      return savedConfig;
    },
    setInterventionsData: function setInterventionsData(interventionsData) {
      saveInterventionsData(store, interventionsData);
    },
    setSystemMessageData: function setSystemMessageData(systemMessageData) {
      saveSystemMessageData(store, systemMessageData);
    },
    getInstance: function getInstance(_ref10) {
      var _ref10$config = _ref10.config,
        config = _ref10$config === void 0 ? null : _ref10$config,
        interventionData = _ref10.interventionData,
        systemMessageData = _ref10.systemMessageData,
        variant = _ref10.variant;
      return new Promise(function (resolve) {
        if (connectionInitiated && instance && instance.client || instance && instance.client && instance.connEstablished) {
          instance.replaceListeners({
            config: config,
            variant: variant
          });
          return resolve(instance);
        }
        savedConfig = config;
        if (interventionData) {
          saveInterventionsData(store, interventionData);
        }
        if (systemMessageData) {
          saveSystemMessageData(store, systemMessageData);
        }
        connectionInitiated = true;
        instance = new XMPPClient(store, {
          config: config,
          variant: variant
        });
        return resolve(instance);
      });
    }
  };
};